var baseAppRequest = require('swa-requests/base-app-request');
var settings = require('swa-app-config/env-settings');
var coreServices = require('swa-app-configuration/core-services');
var customerServices = require('swa-login/customer-services');
var ezrezKeysHomePage = require('swa-bootstrap-data/landing-page/ezrez-keys-home-page');
var landingAirServices = require('swa-landing-page/landing-air-services');

var chapiBasePath = '/api/landing-page/v<%= version %>/landing-page';

settings.configure(
    {
        services: {
            Chapi: {
                name: 'landing-page',
                version: '1'
            }
        },
        urls: {
            AirBookingPurchaseSecureServiceUrl: chapiBasePath + '/purchase-secure',
            AirBookingSaveFlightsServiceUrl: chapiBasePath + '/feature/save-flights',
            AirPriceCompanionServiceUrl: chapiBasePath + '/feature/companion-price',
            CheckoutAccompanyingTravelerRetrieveReservationServiceUrl: chapiBasePath + '/feature/accompanying-traveler-retrieve-reservation',
            CheckoutPricePurchaseServiceUrl: chapiBasePath + '/purchase',
            EarlyBirdCrossSellServiceUrl: '/api/air-booking/v<%= version %>/air-booking/feature/early-bird-cross-sell'
        },
        environmentSpecificData: {
            EzrezKeysHomePage: function (environmentName) {
                return (environmentName === 'prod') ? ezrezKeysHomePage.prod : ezrezKeysHomePage.nonProd;
            }
        }
    },
    coreServices.settings,
    customerServices.settings,
    landingAirServices.settings
);

module.exports = {
    defaults: baseAppRequest.getDefaults(settings),

    secureRules: {},

    services: [
        {
            name: 'AirBookingPurchaseSecureService',
            options: {
                url: settings.getValue('AirBookingPurchaseSecureServiceUrl', settings.services.Chapi)
            }
        },
        {
            name: 'AirBookingSaveFlightsService',
            options: {
                disableServiceTriggeringMaintenanceMode: true,
                url: settings.getValue('AirBookingSaveFlightsServiceUrl', settings.services.Chapi)
            }
        },
        {
            name: 'AirPriceCompanionService',
            options: {
                responseDataHandlers: ['metadata'],
                url: settings.getValue('AirPriceCompanionServiceUrl', settings.services.Chapi)
            }
        },
        {
            name: 'CheckoutAccompanyingTravelerRetrieveReservationService',
            options: {
                disableServiceTriggeringMaintenanceMode: true,
                url: settings.getValue('CheckoutAccompanyingTravelerRetrieveReservationServiceUrl', settings.services.Chapi)
            }
        },
        {
            name: 'CheckoutPricePurchaseService',
            options: {
                disableServiceTriggeringMaintenanceMode: true,
                responseDataHandlers: ['metadata'],
                url: settings.getValue('CheckoutPricePurchaseServiceUrl', settings.services.Chapi)
            },
            secureWhen: ['POINTS', 'COMPANION']
        },
        {
            name: 'EarlyBirdCrossSellService',
            options: {
                disableServiceTriggeringMaintenanceMode: true,
                url: settings.getValue('EarlyBirdCrossSellServiceUrl', settings.services.Chapi)
            }
        },
        ...coreServices.configureServices(settings),
        ...customerServices.configureServices(settings),
        ...landingAirServices.configureServices(settings)
    ]
};